import React, { useEffect, useRef, useState } from "react";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import "../../shared/GuidedInput.css";

const Debuginput = (props) => {
  const fields = [
    { label: "Tunnel Inclination (in tunnel direction)", name: "inclination", type: "number" },
    { label: "Tunnel Direction (Downslope)", name: "direction", type: "number" },
    { label: "Ch. Right SPL", name: "p2", type: "number" },
    { label: "Ch. Left SPL", name: "p4", type: "number" },
    { label: "Ch. Centreline (at Crown)", name: "p5", type: "number" },
    { label: "Tunnel Width at SPL", name: "widthspl", type: "number" },
    { label: "Tunnel Height", name: "height", type: "number" },
    { label: "Wall Height", name: "hw", type: "number" },
  ];

  const [activeFieldIndex, setActiveFieldIndex] = useState(0);
  const [completedFields, setCompletedFields] = useState(new Set());
  const [isEditMode, setIsEditMode] = useState(false);
  const inputRefs = useRef({});

  useEffect(() => {
    const f = fields[activeFieldIndex];
    if (!f) return;
    const el = inputRefs.current[f.name];
    if (!el) return;
    requestAnimationFrame(() => {
      el.focus();
      const rect = el.getBoundingClientRect();
      const inView = rect.top >= 80 && rect.bottom <= window.innerHeight - 80;
      if (!inView) el.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }, [activeFieldIndex]);

  const hasValue = (name) => {
    const v = props.dimensions[name];
    return v !== "" && v !== undefined && v !== null;
  };

  const tryAdvance = (name) => {
    if (!hasValue(name)) return;
    setCompletedFields((prev) => new Set([...prev, name]));
    if (activeFieldIndex < fields.length - 1) {
      setActiveFieldIndex(activeFieldIndex + 1);
    }
  };

  const handleKeyDown = (e, name) => {
    if (e.key === "Enter") {
      e.preventDefault();
      tryAdvance(name);
    }
  };

  const handleFieldClick = (idx) => {
    if (isEditMode || idx <= activeFieldIndex + 1) {
      setActiveFieldIndex(idx);
    }
  };

  const handleEdit = () => {
    setIsEditMode(true);
    setActiveFieldIndex(0);
    setCompletedFields(new Set(fields.map((f) => f.name)));
  };

  const handleReset = () => {
    props.resetvalues();
    setIsEditMode(false);
    setActiveFieldIndex(0);
    setCompletedFields(new Set());
  };

  const isAllComplete = () => fields.every((f) => completedFields.has(f.name));

  const handleNext = () => {
    if (isEditMode) {
      setIsEditMode(false);
      props.showoutput();
      return;
    }
    const active = fields[activeFieldIndex];
    if (active && !completedFields.has(active.name)) {
      tryAdvance(active.name);
      if (!isAllComplete()) return;
    }
    if (!isAllComplete()) return;
    props.showoutput();
  };

  const getFieldClass = (idx, name) => {
    if (isEditMode) {
      return idx === activeFieldIndex
        ? "guided-field guided-field--active"
        : "guided-field guided-field--complete";
    }
    if (idx === activeFieldIndex) return "guided-field guided-field--active";
    if (completedFields.has(name)) return "guided-field guided-field--complete";
    return "guided-field guided-field--pending";
  };

  return (
    <div id="page">
      <Header onBack={props.showobjective} />
      <Footer />
      <div className="page-content header-clear-medium">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="card card-style contact-form">
              <div className="content guided-uniform">
                {fields.map((field, idx) => {
                  const isActive = idx === activeFieldIndex;
                  const isComplete = completedFields.has(field.name);
                  return (
                    <div key={field.name} className="guided-field-wrap">
                      {isActive && !isComplete && (
                        <span className="input-please">Input Please</span>
                      )}
                      <div
                        className={getFieldClass(idx, field.name)}
                        onClick={() => handleFieldClick(idx)}
                      >
                        <div className="guided-field__label">
                          <span>{field.label}</span>
                        </div>
                        <input
                          ref={(el) => (inputRefs.current[field.name] = el)}
                          type={field.type}
                          name={field.name}
                          className="guided-field__input"
                          value={props.dimensions[field.name]}
                          onChange={props.updatedimension}
                          onKeyDown={(e) => handleKeyDown(e, field.name)}
                        />
                      </div>
                    </div>
                  );
                })}
                <input type="hidden" name="width" value={props.dimensions.width} readOnly />
                <div className="guided-input-actions mt-4">
                  <button
                    type="button"
                    className="btn bg-red-dark text-uppercase font-900 btn-m rounded-sm shadow-xl"
                    onClick={handleReset}
                  >
                    Reset Values
                  </button>
                  <button
                    type="button"
                    className="btn bg-secondary text-uppercase font-900 btn-m rounded-sm shadow-xl"
                    onClick={handleEdit}
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    className="btn bg-green-dark text-uppercase font-900 btn-m rounded-sm shadow-xl"
                    onClick={handleNext}
                    disabled={!isEditMode && !isAllComplete()}
                  >
                    {props.label}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Debuginput;
